export const  APP_ID = '400af929b16c484e93501682ab2c64cc';



export const JAWAB = 'JAWAB'
export const BERDERING = 'BERDERING'
export const DITOLAK = 'DITOLAK'
export const SELESAI = 'SELESAI'
export const APP_VERSION = '3.2'
// const BERDERING = 'BERDERING'



export function generateRandomText(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    
    let result = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }

    return result;
}
